import isEmpty from "lodash/isEmpty";
import type { PropsWithChildren } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { PRODUCT_ID_QUERY_PARAM_NAME } from "../../../../constants/commonStrings";
import { useDynamicPaywallProductId } from "../../../../hooks/feature-flags/useDynamicPaywallProductId/useDynamicPaywallProductId";
import { PRODUCT_PRICING_PAGE_MAP } from "../../../../legacy/pages/pricing-page/config/product-pricing-page-map";

function DynamicPaywallRedirect({ children }: Readonly<PropsWithChildren<{}>>): JSX.Element {
  const productId = useDynamicPaywallProductId();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isDirectAccess = location.key === "default";

  const hasValidProductId = !isEmpty(productId) && productId in PRODUCT_PRICING_PAGE_MAP;
  const isProductIdParamMissing = !searchParams.has(PRODUCT_ID_QUERY_PARAM_NAME);

  if (hasValidProductId && isProductIdParamMissing) {
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set(PRODUCT_ID_QUERY_PARAM_NAME, productId);
    return (
      <Navigate to={{ search: nextSearchParams.toString() }} state={{ ...location.state, isDirectAccess }} replace />
    );
  }

  return <>{children}</>;
}

export default DynamicPaywallRedirect;
